import type { closeModal } from "../state/modals";
import type { Middleware } from "redux";

import { sawAuthenticationModal, signedInUser } from "./events/authentication";
import { openModal } from "../state/modals";
import { logUserIn } from "../state/user";

const AUTHENTICATION_MODAL = "authentication";

type HandledAction = typeof openModal | typeof closeModal | typeof logUserIn;

export const authenticationTrackingMiddleware: Middleware =
  () => next => (action: HandledAction) => {
    // In order to reduce State resolution time, tracking is delayed until next tick
    setTimeout(() => {
      if (action && logUserIn.match(action)) {
        signedInUser(action.payload.user, action.payload.sign_in_method);
      }
      if (action && openModal.match(action)) {
        action.payload.type === AUTHENTICATION_MODAL &&
          sawAuthenticationModal();
      }
    }, 0);

    return next(action);
  };
